import { Injectable, signal, computed } from '@angular/core';

export enum SidebarTab {
  Navigation = 'navigation',
  News = 'news',
  Notifications = 'notifications',
}

@Injectable({
  providedIn: 'root',
})
export class SidebarService {
  private readonly _isOpen = signal(false);
  private readonly _isMobile = signal(window.innerWidth <= 800);
  private readonly _activeTab = signal<SidebarTab>(SidebarTab.News);

  public readonly activeTab = computed(() => this._activeTab());

  public readonly isOpen = computed(() => this._isOpen());
  public readonly isMobile = computed(() => this._isMobile());

  public toggle(): void {
    this._isOpen.update(open => !open);
  }

  public open(tab: SidebarTab): void {
    this._isOpen.set(true);
    this._activeTab.set(tab);
  }

  public close(): void {
    this._isOpen.set(false);
  }

  public setIsMobile(isMobile: boolean): void {
    this._isMobile.set(isMobile);
  }
}
